/* eslint-disable @typescript-eslint/no-namespace */
export type Location = {
    latitude: number;
    longitude: number;
    address: string;
};

export namespace Location {
    export const isValid = (location: Location): boolean => {
        return location.latitude >= 0 && location.longitude >= 0 && location.address !== "";
    };
}
